import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery'
import Layout from '~/components/Layout'
import i18n from '~/components/i18n'
import TableComponent from '~/components/TableComponent'
import { useDebounce } from 'use-lodash-debounce';
import { FilterWrapper } from '../../DairyFactory/Farmers/style'
import { Dropdown, Input } from 'semantic-ui-react'

const getDefaultTableComunHeaders = () => [
  {
    name: i18n.t('AGIS-ID Betrieb'),
    key: 'agisId',
    sorted: 'desc'
  },
  {
    name: i18n.t('EVS-Nr.'),
    key: 'evsNumber'
  },
  {
    name: i18n.t('Company name'),
    key: 'companyName'
  },
  {
    name: i18n.t('Fat (in %)'),
    key: 'fat',
    type: 'no-unit-number',
    sorted: 'desc'
  },
  {
    name: i18n.t('Protein (in %)'),
    key: 'protein',
    type: 'no-unit-number',
    sorted: 'desc'
  },
  {
    name: i18n.t('Germ count (1000/ml)'),
    key: 'germCount',
    type: 'no-unit-number',
    decimalScale: 0,
    sorted: 'desc'
  },
  {
    name: i18n.t('Cell count (1000/ml)'),
    key: 'cellCount',
    type: 'no-unit-number',
    decimalScale: 0,
    sorted: 'desc'
  },
  {
    name: i18n.t('Inhibitor'),
    key: 'inhibitorLabel'
  },
  {
    name: i18n.t('Urea (mg/dl)'),
    key: 'urea',
    type: 'no-unit-number-no-value',
    sorted: 'desc'
  }
]

const defaultDataFilter = {
  page: 0,
  rows: 20,
  month: '',
  search: ''
}

const SwissAvgFarmerValues: React.FC = () => {
  const { t } = useTranslation()

  const [search, setSearch] = useState('')
  const debouncedSearchValue = useDebounce(search, 300)
  const [dataFiltered, setDataFiltered] = useState(defaultDataFilter)
  const [tableColumnHeaders, setTableColumnHeaders] = useState(getDefaultTableComunHeaders())

  useEffect(() => {
    fetchOptions()
    setTableColumnHeaders(getDefaultTableComunHeaders())
  }, [t])

  const {
    isLoading: isBusyData,
    data: milkSamplesData,
    refetch: fetchFilteredData,
    isFetching: isFetchingData
  } = MilkMoneyQuery.getSwissAvgFarmerValues({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  });

  const {
    isLoading: isBusyOptions,
    data: milkSamplesOptions,
    refetch: fetchOptions
  } = MilkMoneyQuery.getSwissAvgFarmerValuesOptions()

  useEffect(() => {
    fetchFilteredData()
  }, [dataFiltered]);

  useEffect(() => {
    if (milkSamplesOptions?.months?.length > 0 && !dataFiltered?.month) {
      setDataFiltered({
        ...dataFiltered,
        month: milkSamplesOptions?.months[0]?.key
      })
    }
  }, [milkSamplesOptions])

  useEffect(() => {
    setDataFiltered({ ...dataFiltered, search: debouncedSearchValue, page: 0 });
  }, [debouncedSearchValue]);

  function renderFilters() {
    return <FilterWrapper>
      <Dropdown
        selection
        options={milkSamplesOptions?.months?.map(month => ({ value: month.key, text: month.label }))}
        value={dataFiltered.month}
        onChange={(_, { value }) => {
          setDataFiltered({
            ...dataFiltered,
            month: value as string
          })
        }}
        placeholder={t('Procurement month')}
      />
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('EVS-Nr. /  Betriebsname')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
    </FilterWrapper>
  }

  function renderTable() {
    return <TableComponent
      isFetchingData={isFetchingData}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data, tableColumnHeaders) => {
        setTableColumnHeaders(tableColumnHeaders)
        setDataFiltered(data)
      }}
      rows={rows}
      total={filtered}
    />
  }

  const { filtered, rows } = milkSamplesData ? milkSamplesData : { filtered: 0, rows: [] };

  return <Layout
    segmented
    isBusy={isBusyData || isBusyOptions}
    title={t('Overview of average values')}
    filters={milkSamplesOptions && renderFilters()}
  >
    {renderTable()}
  </Layout>
}
export default SwissAvgFarmerValues
